<script setup lang="ts">
defineOptions({
	name: 'JurisdictionSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-ic:outline-account-balance"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Applicable Law and Jurisdiction') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						`This Policy, as well as the collection, processing, or transmission of Users’ Personal Data, is governed by the provisions of the GDPR and by the legislation and regulations applicable in Portugal`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`Any disputes arising from the validity, interpretation, or execution of this Policy, or which are related to the collection, processing, or transmission of each User’s Personal Data, shall comply with the rules established in the Platform’s Terms & Conditions`,
					)
				}}.
			</p>

			<p class="text-right text-base pt-10 italic">{{ $t('Date of last update: 18 November 2025') }}</p>
		</div>
	</section>
</template>
